 import authHeader from "../../../authentication/authservices/auth-header";
import apiClient from "../../../http-common";


export const saveACSTimeline = async (postObj) => {
  return await apiClient.post(`/patientEmergencyInfo/saveAcs`, postObj, {
    headers: authHeader(),
  });
};
export const getACSTimeLineByPatientId = async (EmergencyId) => {
  return await apiClient.get(
    `/patientEmergencyInfo/getAcsInfo/${EmergencyId}`,
    {
      headers: authHeader(),
    },
  );
};